import React from 'react';
import { AVAILABILITY_OPTIONS, DEBOUNCE_TIME } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { history } from 'src/services/history';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { TOOLTIP_DURATION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import LazyCategoriesPicker from 'src/view/components/Controls/Pickers/LazyCategoriesPicker/LazyCategoriesPicker';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';
import './style.scss';
import { ButtonAppearance } from '~/view/components/Controls/ButtonComponent/types';
import { SCREENS } from '~/constants/screens';

interface IProps {
  createPath: string;
  availability?: AVAILABILITY_OPTIONS | undefined;
  search: string | undefined;
  loading?: boolean;
  isShowImproveMenu?: boolean;
  foundItemsInSystem?: boolean; // whether there is an items in system. Whether deleted or not
  createButtonTitle: string;
  createButtonDisabled?: boolean;
  setSearch: (search: string) => void;
  selectAvailability?: (options: IPickerOption[]) => void;
  //
  includeDeleteOption?: boolean;
  //
  includeAvailabilityPicker?: boolean;
  includeCategoryPicker?: boolean;
  selectedCategory?: IPickerOption[];
  selectCategory?: (options: IPickerOption[]) => void;
  //
  posRestrictionOnCreate?: boolean;
}

interface IState {
  tooltip: boolean;
}

export default class MenuManagTabHeader extends React.Component<IProps, IState> {
  state = {
    tooltip: false,
  };

  selectAvailability = (options: IPickerOption[]) => {
    if (this.props.selectAvailability) this.props.selectAvailability(options);
  };

  selectCategory = (options: IPickerOption[]) => {
    if (this.props.selectCategory) this.props.selectCategory(options);
  };

  createItem = () => {
    if (this.props.createButtonDisabled) return;

    if (this.props.posRestrictionOnCreate) {
      this.setState({ tooltip: true });
      return;
    }

    history.push(this.props.createPath);
  };

  handleImproveMenu = () => {
    if (this.props.createButtonDisabled) return;

    if (this.props.posRestrictionOnCreate) {
      this.setState({ tooltip: true });
      return;
    }

    history.push(SCREENS.MENU_GROUP_IMPROVEMENT());
  };

  setSearch = (search: string) => {
    this.props.setSearch(search);
  };

  get availabilityOptions(): IPickerOption[] {
    const _options: IPickerOption[] = [
      { label: localeStore.t(AVAILABILITY_OPTIONS.AVAILABLE), value: AVAILABILITY_OPTIONS.AVAILABLE },
      { label: localeStore.t(AVAILABILITY_OPTIONS.NOT_AVAILABLE), value: AVAILABILITY_OPTIONS.NOT_AVAILABLE },
    ];

    if (this.props.includeDeleteOption) _options.push({ label: localeStore.t(AVAILABILITY_OPTIONS.DELETED), value: AVAILABILITY_OPTIONS.DELETED });

    return _options;
  }
  get availabilitySelectedOptions(): IPickerOption[] {
    if (!this.props.availability) return [];

    return [{ label: localeStore.t(this.props.availability), value: this.props.availability }];
  }

  get available(): boolean {
    return Boolean(
      this.props.foundItemsInSystem || this.props.loading || this.props.search || this.props.availability || this.props.selectedCategory
    );
  }

  render() {
    return (
      <div className={`d-flex flex-row mr-4 ${this.available ? 'justify-content-between' : 'justify-content-end'} `}>
        {this.available ? (
          <div className="d-flex flex-row">
            <SearchInput
              value={this.props.search}
              onChangeText={this.setSearch}
              loading={this.props.loading}
              debounceDelay={DEBOUNCE_TIME.MEDIUM}
              withResetIcon
              customPlaceholder
              placeholder="txt_search"
              className="menu-manag-tab-header__search mr-2"
              inputClassName="color-dark text-size-16 family-medium"
            />
            {this.props.includeCategoryPicker ? (
              <LazyCategoriesPicker
                searchable
                selectedOptions={this.props.selectedCategory}
                onSelect={this.selectCategory}
                className="menu-manag-tab-header__filter mr-2"
              />
            ) : null}
            {this.props.includeAvailabilityPicker ? (
              <Picker
                options={this.availabilityOptions}
                selectedOptions={this.availabilitySelectedOptions}
                onSelect={this.selectAvailability}
                placeholder={localeStore.t('select_availability')}
                listClassName="menu-manag-tab-header__filter"
              />
            ) : null}
          </div>
        ) : null}
        <div className="d-flex align-items-center">
          {this.props.posRestrictionOnCreate && !this.props.createButtonDisabled ? (
            <TooltipIcon
              message="please_disable_posint"
              duration={TOOLTIP_DURATION.EXTRA_LARGE}
              trigger={this.state.tooltip}
              disableTrigger={() => this.setState({ tooltip: false })}
              maxWidth={385}
              iconClassName="mr-3"
            />
          ) : null}
          {this.props.isShowImproveMenu && (
            <Button
              title={localeStore.t('menu_healthchecker_btn')}
              onClick={this.handleImproveMenu}
              className="mr-2"
              appearance={ButtonAppearance.TERTIARY}
              disabled={this.props.posRestrictionOnCreate || this.props.createButtonDisabled}
              loading={this.props.loading}
            />
          )}
          <Button
            title={localeStore.t(this.props.createButtonTitle)}
            onClick={this.createItem}
            disabled={this.props.posRestrictionOnCreate || this.props.createButtonDisabled}
            loading={this.props.loading}
          />
        </div>
      </div>
    );
  }
}
